<template>
  <div
    class="layout-fixed-header-section d-lg-flex d-block justify-content-between align-items-center"
  >
    <div class="header-label col-lg-6 col-md-6 col-12 m-8">
      <div
        class="main-header-label text-ellipsis"
        style="width: 100%"
        :title="getComputedHeaderLabel"
      >
        {{ getComputedHeaderLabel }}
      </div>
    </div>
    <div
      class="header-right-section col-md-6 col-lg-6 col-12 text-end d-flex justify-content-end align-items-center"
    >
      <div
        class="header-right-area input-group justify-content-end mx-2 d-none"
      >
        <span
          class="input-group-text min-width-120 border-0 header-search-icon"
          id="basic-addon1"
          style="background-color: #eceff4; color: #7f7f7f; font-size: medium"
        >
          <img
            src="../../public/assets/images/icon/header-search-icon.svg"
            alt="Search Icon"
            width="14"
            height="14"
          />
        </span>
        <input
          type="text"
          v-model="state.searchAll"
          class="form-control search-all-field mr-2 border-0 align-items-center"
          id="searchallInput"
          placeholder="Search"
          autocomplete="off"
          maxlength="10"
          v-on:keyup.enter="null"
          @paste="null"
          @keypress="mobileSearchFormat"
        />
      </div>

      <!-- <button type="button" class="btn position-relative notification-btn mx-2">
        <i
          class="pi pi-bell fw-bold notification-bell-icon"
          aria-hidden="true"
        ></i>
      </button> -->
      <div class="profile-signout-dropdown-outer mx-2">
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle switch-branch-btn text-truncate d-inline-block"
            type="button"
            id="switchdealerbranch"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <img
                  v-if="
                    checkEmpty(state.useraadharphoto) &&
                    state.setProfileTypePhoto == 1
                  "
                  :src="state.user_aadhar_photo"
                  class="profile-header-avatar rounded-circle"
                  alt=""
                  width="30"
                  height="30"
                />
                <img
                  v-else-if="
                    checkEmpty(state.uservoterphoto) &&
                    state.setProfileTypePhoto == 2
                  "
                  :src="state.user_votercard_photo"
                  class="profile-header-avatar rounded-circle"
                  alt=""
                  width="30"
                  height="30"
                />
                <img
                  v-else
                  src="../../public/assets/images/profile.svg"
                  class="profile-header-avatar rounded-circle"
                  alt=""
                  width="30"
                  height="30"
                />
              </div>
              <div class="flex-grow-1 ms-2 profile-logged-name text-capitalize">
                {{ state.user_name ? state.user_name : "Dummy user" }}
              </div>
            </div>
          </button>
          <ul class="dropdown-menu pt-2" aria-labelledby="switchdealerbranch">
            <li>
              <router-link class="dropdown-item" to="/myprofile"
                ><i class="pi pi-user me-2"></i>My Profile</router-link
              >
            </li>
            <li>
              <span
                class="dropdown-item cursor-pointer"
                @click="logout"
                v-if="!state.logoutshowloader"
                ><i class="pi pi-sign-out me-2"></i>Sign Out</span
              >
              <div
                class="spinner-border text-light custom-spinner-loader-btn"
                v-if="state.logoutshowloader"
              ></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import commonFunctions from "../composables/commonFunction";
import ApiService from "../service/ApiService";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const { checkEmpty } = commonFunctions();

    const state = reactive({
      searchAll: "",
      headerLabel: "DashBoard",
      user_name: "",
      user_image: "",
      uservoterphoto: "",
      client_info: "",
      // party_logo: "",
      baseUrl: window.location.origin,
      user_votercard_photo: "",
      user_aadhar_photo: "",
      useraadharphoto: "",
      voterstorageimgpath: "",
      setProfileTypePhoto: "",
      logoutshowloader: false,
    });

    onMounted(() => {
      const loggedUserData = store.state.loggedInUserSessions;

      if (loggedUserData) {
        state.user_name = loggedUserData.user.user_short_name;
        state.uservoterphoto = loggedUserData.user.ak90;
        state.useraadharphoto = loggedUserData.user.ak33;
        state.setProfileTypePhoto = loggedUserData.user.ak151;
        state.client_info = loggedUserData.client_info;
        state.user_image = loggedUserData.uservoterphoto;
        state.voterstorageimgpath = loggedUserData.client_info.maa24;
        state.user_votercard_photo =
          "https://storage.googleapis.com/" +
          state.voterstorageimgpath +
          "/voterphoto/" +
          state.uservoterphoto;

        state.user_aadhar_photo =
          "https://storage.googleapis.com/" +
          state.voterstorageimgpath +
          "/aadharphoto/" +
          state.useraadharphoto;

      }
    });

    const getComputedHeaderLabel = computed(() => {
      switch (true) {
        case route.path.startsWith("/dashboard"):
          return "Dashboard";
        case route.path.startsWith("/voters/add"):
          return "Add Voter";
        case route.path.startsWith("/voters/incompletevoters"):
          return "Incomplete Voters List";
        case route.path.startsWith("/voters/voterslist"):
          return "Voters List";
        case route.path.startsWith("/voters/unassignedvoters"):
          return "Unassigned Voters List";
        case route.path.startsWith("/voters/mismatchedVoters"):
          return "Mismatched Voters";
        case route.path.startsWith("/voters/import"):
          return "Import Voters";
        // case route.path.startsWith("/voters/previousfollowup"):
        //   return "Previous Followups";
        case route.path.startsWith("/voters/pendingfollowup"):
          return "Pending Followups";
        case route.path.startsWith("/voters/todayfollowup"):
          return "Today's Followups";
        case route.path.startsWith("/voters/search"):
          return "Search Voters";
        case route.path.startsWith("/user/add"):
          return "All Users List";
        case route.path.startsWith("/user/listing"):
          return "Users Listing";
        case route.path.startsWith("/user/permissionsets"):
          return "Users Permission";
        case route.path.startsWith("/campaign/campaigntemplate"):
          return "Campaigns Template";
        case route.path.startsWith("/campaign/whatsapplogs"):
          return "WhatsApp Campaign Logs";
        case route.path.startsWith("/campaign/smslogs"):
          return "SMS Campaign Logs";
        case route.path.startsWith("/campaign/pushlogs"):
          return "Push Campaign Logs";
        case route.path.startsWith("/campaign/calllogs"):
          return "Call Campaign Logs";
        case route.path.startsWith("/campaign"):
          return "Campaign List";
        case route.path.startsWith("/logs/sms"):
          return "SMS Logs";
        case route.path.startsWith("/logs/webbotlogs"):
          return "Web Bot Logs";
        case route.path.startsWith("/logs/myincoming"):
          return "Incoming Call Logs";
        case route.path.startsWith("/logs/myoutgoing"):
          return "Outgoing Call Logs";
        case route.path.startsWith("/logs/email"):
          return "Email Logs";
        case route.path.startsWith("/logs/aadhar-v1-card"):
          return "Aadhaar Logs";
        case route.path.startsWith("/logs/voter/_search"):
          return "Voter Card Logs";
        case route.path.startsWith("/logs/pan-card"):
          return "PAN Card Logs";
        case route.path.startsWith("/logs/driving-licence"):
          return "Driving Licence Logs";
        case route.path.startsWith("/logs/passport"):
          return "Passport Logs";
        case route.path.startsWith("/logs/importvoter"):
          return "Import Logs";
        case route.path.startsWith("/settings/designation"):
          return "Name of Designations";
        case route.path.startsWith("/settings/tags"):
          return "Voter Tags";
        case route.path.startsWith("/support/user"):
          return "User Support Tickets";
        case route.path.startsWith("/support/app"):
          return "App Support Tickets";
        case route.path.startsWith("/appsupport/new"):
          return "New App Support Tickets";
        case route.path.startsWith("/appsupport/open"):
          return "Open App Support Tickets";
        case route.path.startsWith("/appsupport/closed"):
          return "Closed App Support Tickets";
        case route.path.startsWith("/appsupport/settings"):
          return "App Support Settings";
        case route.path.startsWith("/settings/eventsettings"):
          return "Event Setting";
        case route.path.startsWith("/settings/ticketsettings"):
          return "Ticket Setting";
        case route.path.startsWith("/cloudtelephony/virtualnumbers"):
          return "Virtual Numbers";
        case route.path.startsWith("/cloudtelephony/customtunes"):
          return "Custom Tunes";
        case route.path.startsWith("/billing/dashboard"):
          return "Billing Dashboard";
        case route.path.startsWith("/billing/invoice"):
          return "Tax Invoices";
        case route.path.startsWith("/billing/statement"):
          return "Main Account Statement";
        case route.path.startsWith("/billing/receipt"):
          return "Payment Receipts";
        case route.path.startsWith("/companydetails"):
          return "Company Details";
        case route.path.startsWith("/jantadarbarparticipant"):
          return "Janta Darbar Participants";
        case route.path.startsWith("/jantadarbar"):
          return "Janta Darbar";
        case route.path.startsWith("/approvals/myrequest"):
          return "My Request";
        case route.path.startsWith("/approvals/teamsrequest"):
          return "Teams Request";
        case route.path.startsWith("/approvals/approverequest"):
          return "Request To Approve";
        case route.path.startsWith("/generateaudio"):
          return "Generate Audio Clips";
        case route.path.startsWith("/birthdays"):
          return "Birthdays";
        case route.path.startsWith("/appusers"):
          return "";
        case route.path.startsWith("/myprofile"):
          return "My Profile";

        case route.path.startsWith("/karyakartas/add"):
          return "Add Karyakarta";
        case route.path.startsWith("/karyakartas/list"):
          return "Karyakarta List";
        case route.path.startsWith("/jobopportunities"):
          return "Job Opportunities";
        case route.path.startsWith("/bloodbank"):
          return "Online Blood Bank";
        case route.path.startsWith("/plasma"):
          return "Online Plasma";
        case route.path.startsWith("/schemes"):
          return "Government Schemes";
        case route.path.startsWith("/app-popup"):
          return "App Popup";
        default:
          return "Dashboard";
      }
    });
    const apiService = new ApiService();
    const toast = useToast();

    const logout = () => {
      state.logoutshowloader = true;
      apiService.logout().then((data) => {
        if (data.status == 200) {
          var successMsg = data.message;
          toast.open({
            message: successMsg,
            type: "success",
            duration: 3000,
            position: "top-right",
          });
          state.logoutshowloader = false;
        } else {
          var errorMsg = data.message;
          if (errorMsg != "") {
            toast.open({
              message: errorMsg,
              type: "error",
              duration: 3000,
              position: "top-right",
            });
          }
          state.logoutshowloader = false;
        }
      });
    };

    return { state, getComputedHeaderLabel, checkEmpty, logout };
  },
};
</script>
<style scoped>
.profile-header-avatar {
  padding: 2px;
}

.layout-fixed-header-section {
  border-radius: 0px;
  padding: 9px 16px;
  position: sticky;
  top: 0;
  z-index: 11;
  background: #ffffff;
}

.layout-fixed-header-section .header-right-section .header-right-area .header {
  background: #eceff4;
}

.layout-fixed-header-section .search-all-field {
  background: #eceff4;
  height: 35px;
  min-width: 50px;
  max-width: 365px;
  width: 365px;
}

.layout-fixed-header-section .header-search-icon {
  background: #eceff4;
}

.layout-fixed-header-section .header-label {
  font-size: 23px;
  font-weight: 600;
}

.layout-fixed-header-section .notification-btn {
  color: #373737;
  background-color: #f4f4f4;
  border: 1px solid #838383;
  border-radius: 11px;
  height: 35px;
  width: 35px;
  padding: 8px;
}
</style>
